import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-home',
  templateUrl: './training-home.component.html',
  styleUrls: ['./training-home.component.scss']
})
export class TrainingHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
    window.scroll(0,0);
    
  }

}
